import axios from 'axios';

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Replace with your API base URL
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('_auth'); // Retrieve token from localStorage

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    if (error?.response?.status === 401) {
      // Token is invalid/expired, log out or redirect to login
      
    }
    // Handle request error
    return Promise.reject(error);
  }
);

export default api;




